import { AlertTriangle, CheckCircle2, Loader2, XCircle } from 'lucide-react'
import { cn } from '../lib/cn'

export type TraceStatus = 'ok' | 'running' | 'warn' | 'error'

export interface TraceLineProps {
  /** What was read: "Conduit record", "PBX /diagnose", "Cambium AP", "UniFi WAN". */
  source: string
  detail: string
  status: TraceStatus
  at?: string
  /** Riley read its own earlier write-back: render as such, never as independent evidence. */
  selfCitation?: boolean
  className?: string
}

const ICON = {
  ok: <CheckCircle2 className="size-4 text-success" aria-label="ok" />,
  running: <Loader2 className="size-4 animate-spin text-riley" aria-label="running" />,
  warn: <AlertTriangle className="size-4 text-warning" aria-label="warning" />,
  error: <XCircle className="size-4 text-destructive" aria-label="failed" />,
}

/** One uniform line per read Riley made (scope §6.3 Trace). */
export function TraceLine({ source, detail, status, at, selfCitation, className }: TraceLineProps) {
  return (
    <div data-status={status} className={cn('flex items-center gap-2.5 py-1.5 text-sm', className)}>
      <span className="font-semibold text-foreground">{source}</span>
      <span className="min-w-0 flex-1 truncate text-muted-foreground" title={detail}>
        · {detail}
        {selfCitation ? <span className="ml-1 text-xs text-warning">(Riley’s own write-back)</span> : null}
      </span>
      {at ? <time className="shrink-0 text-xs text-subtle">{at}</time> : null}
      {ICON[status]}
    </div>
  )
}
